import React from 'react'
import { PaymentElement, LinkAuthenticationElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useState } from 'react'
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const CheckoutForm = ({ orderId }) => {

    localStorage.setItem('orderId', orderId)
    const stripe = useStripe()
    const elements = useElements()
    const [message, setMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const paymentElementOptions = {
        loyout: 'tabs'
    }

    const submit = async (e) => {
        e.preventDefault()

        if (!stripe || !elements) {
            return
        }
        setIsLoading(true)
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `/order/confirm`
            }
        })
        if (error.type === 'card_error' || error.type === 'validation_error') {
            setMessage(error.message)
        } else {
            setMessage('An unexpected error occurred')
        }
        setIsLoading(false)
    }

    return (
        <form className=' flex gap-4 flex-col justify-center items-center  rounded-lg' onSubmit={submit} id='payment-form' >
            <LinkAuthenticationElement
                id='link-authentication-element'
            />
            <PaymentElement id='payment-element' options={paymentElementOptions} />

            <button disabled={isLoading || !stripe || !elements} id='submit' className='mt-5 px-10 py-[6px] rounded-lg hover:shadow-green-500/20 hover:shadow-lg bg-green-500 text-white'>
                <span id='button-text'>
                    {
                        isLoading ? <div className='flex items-center '>Loading<AiOutlineLoading3Quarters className='animate-spin ml-2' />
                        </div> : "Pay now"
                    }
                </span>
            </button>
            {message && <div>{message}</div>}
        </form>
    )
}

export default CheckoutForm